import React from "react";
import Citations from "../../../../components/Citations";

const DbnsfpCitations = () => (
  <Citations>
    <div>
      <div>
        <strong>dbNSFP</strong>
      </div>
      <p>
        1. Liu X, Jian X, and Boerwinkle E. 2011. dbNSFP: a lightweight database
        of human non-synonymous SNPs and their functional predictions.
        <i>{"Human Mutation. "}</i>
        32:894-899.
      </p>
      <p>
        2. Liu X, Wu C, Li C and Boerwinkle E. 2016. dbNSFP v3.0: A One-Stop
        Database of Functional Predictions and Annotations for Human
        Non-synonymous and Splice Site SNVs.
        <i>{"Human Mutation. "}</i>
        37:235-241.
      </p>
      <p>
        3. Dong C, Wei P, Jian X, Gibbs R, Boerwinkle E, Wang K_ and Liu X_.
        (2015) Comparison and integration of deleteriousness prediction methods
        for nonsynonymous SNVs in whole exome sequencing studies.
        <i>{"Human Molecular Genetics "}</i>
        24(8):2125-2137.
      </p>
    </div>
  </Citations>
);

export default DbnsfpCitations;
